<template>
  <div class="main-page" :key="keypage">
    <Menus :title="title" :border="true">
      <a href="javascript:void(0)" @click="goback">
        <div class="img_block">
          <img class="img_margin" :src="`${$root.statics}/img/icon/back_white.png`" alt="返回" />
        </div>
        <span>返回</span>
      </a>
    </Menus>
    <div class="container-flex_content">

      <!-- 接通律师/ 通话中 -->
      <div v-show="step === 1 || step === 2" class="content">
        <div class="videoconsult" v-show="step == 1">
          <div class="default-lawyer"></div>
        </div>
        <div class="videoconsult" v-show="step === 2 && connectType === 'video'">
          <div id="lawyer" class="target-video-container">
            <video class="video2" autoplay ref="targetVideo" />
          </div>
          <div id="person" class="self-video-container" ref="self-video-container">
            <video class="video3" autoplay ref="selfVideo" muted />
          </div>
        </div>
        <div class="videoconsult" v-show="step === 2 && connectType === 'audio'">
          <div class="default-mike"></div>
        </div>

        <div class="intro" v-if="step === 1">
          <div class="info">
            服务时间：周一 ~ 周五
            <br />
            <b style="font-size: 12px;margin: 5px 0;color: #2d2d2d;">
              视频测速：⬇ {{ averageNetWorkSpeed && averageNetWorkSpeed.download.toFixed(2) }}Mbps，⬆ {{ averageNetWorkSpeed && averageNetWorkSpeed.upload.toFixed(2) }}Mbps
              <i style="display: block;">(若测速未达到2Mbps则自动切为语音咨询)</i>
            </b>
            <br>
            <div class="tip" v-if="isconnecting">
              正在接通{{ people }}，请稍等...
            </div>
            <span style="color: red;font-size:0.3rem;" v-if="alert.info">
              <br />
              {{ alert.info }}
            </span>
          </div>
          <div class="btns" v-if="allowVideo && averageNetWorkSpeed.download > 0">
            <button class="button " @click="demoCall(cid)">视频咨询</button>({{worktime[0]}})
          </div>
          <div class="btns" v-if="allowVoice && averageNetWorkSpeed.download > 0">
            <button class="button " @click="voiceCall">语音咨询</button>({{worktime[1]}})
          </div>
          <p v-if="!allowVideo && !allowVoice">当前时间段暂不支持语音/视频咨询</p>
        </div>
        <div v-if="step === 2" class="intro">
          <!-- <div class="lawyer">
            张小明
            <span>律师</span>
          </div>
          <div class="organ">
            三亚市公共法律服务中心
          </div>-->
          <div class="voicestatus">
            服务时间：周一 ~ 周五（工作时间）
            <br />
            通话中：
            <span>{{ timed }}</span>
          </div>
          <div class="btns">
            <button class="button active" @click="hangup">挂断</button>
          </div>
        </div>
      </div>
      <!-- 评价 -->
      <div v-if="step === 3" class="content">
        <div class="evaluation">
          <div class="title">您好，本次咨询结束，欢迎下次咨询！</div>
          <div class="evaluation-con">
            <div class="item" :class="{ 'active': currentStars == 5 }" @click="currentStars = 5">
              <div class="imgs">
              </div>非常满意
            </div>
            <div class="item" :class="{ 'active': currentStars == 4 }" @click="currentStars = 4">
              <div class="imgs">
              </div>很满意
            </div>
            <div class="item" :class="{ 'active': currentStars == 3 }" @click="currentStars = 3">
              <div class="imgs">
              </div>满意
            </div>
            <div class="item" :class="{ 'active': currentStars == 2 }" @click="currentStars = 2">
              <div class="imgs">
              </div>一般
            </div>
            <div class="item" :class="{ 'active': currentStars == 1 }" @click="currentStars = 1">
              <div class="imgs">
              </div>很差
            </div>
          </div>
          <div class="button" @click="sendEvaluate">
            评价
          </div>
        </div>
      </div>
      <!-- 评价完成-->
      <div v-if="step === 4" class="content">
        <div class="success-info">
          <div class="success-icon" />
          <div class="title">评价完成</div>
          <div class="desc">感谢您的支持，我们会继续为您提供优质服务！</div>
          <button class="button " @click="$router.replace('/')">返回首页</button>
          <button class="button " @click="reCall">再次咨询</button>
        </div>
      </div>
    </div>
    <Dialogs v-model="dialog">
      <div class="body">
        <div class="item c1">
          <div class="title">请按依次上传相应材料</div>
          <div class="material">
            <div class="info">
              <span>提示：请将文件放入左下方扫描位置,点击扫描，所有文件扫描完成后点击提交全部材料按钮进行提交！</span>
              <button @click="getScanning">扫描</button>
            </div>
            <div id="scan" class="material-con" />
          </div>
        </div>
        <div class="item c2">
          <div class="title">已扫描资料</div>
          <div class="material">
            <div class="materimg">
              <template v-if="materiallist.length">
                <div v-for="(item, index) in materiallist" :key="'key-' + index" class="mater-img-item" :class="[(index + 1) % 3 == 0 ? 'nomargin' : '']">
                  <div class="delete" @click="deletePhoto(index, materiallist)" />
                  <img :src="item" alt />
                </div>
              </template>
              <div v-else style="padding:0.3rem 0;color:#999;font-size:0.24rem">暂无</div>
            </div>
            <div class="button" @click="sendToLawyerClick(uploadedUrl)">提交全部材料</div>
            <div class="tipinfo">全部文件上传后点击”提交全部材料”完成申请</div>
          </div>
        </div>
      </div>
      <div class="closedialog" @click.stop="closeDialog">
        <img :src="`${$root.statics}/img/icon/close.png`" alt />
      </div>
    </Dialogs>
    <Dialogs v-model="prompt">
      <div class="body">
        <img src="/img/ui/video-prompt.jpg" alt style="width: 100%;" />
      </div>
      <template #foot>
        <a class="lp-btn large primary submit-btn" @click="prompt.show = false; rtcConnectFunction();">已知晓</a>
      </template>
    </Dialogs>
    <div v-if="infoupload" class="uploadinfo">
      <div class="masks" />
      <div class="infocontent">
        <div class="infotitle">提示</div>
        <div class="infotxt">{{ infouploadtxt }}</div>
        <button @click="closeUploadinfo">确定</button>
      </div>
    </div>
    <Alert v-if="alert.show" :info="alert.info" :recall="alert.recall" @setClose="value => alert.show = value ">
    </Alert>

  </div>
</template>
<script>
import Vue from 'vue'
import { socketInitialization } from '@/lib/socket.js'

import Menus from '@/components/Menu'
import Dialogs from '@/components/Dialog'
import { dataURLtoBlob, removeByValue } from '@/fun.js'
import { testNetworkSpeed } from '@/lib/netSpeed.js'
import Alert from '@/components/Alert'
import { speak } from '@/datas/js/common'

// import easyrtc from 'easyrtc'
import { v4 as generateUUID } from 'uuid'
import WebRTCPlus from "webrtc-plus";
import emitter from '@/lib/event.js'
import { getDeviceRule, confirmEvaluate } from '@/lib/request.js';
import dayjs from 'dayjs'

export default {
  components: {
    Menus,
    Dialogs,
    Alert
  },
  data () {
    return {
      title: '',
      step: 1,
      averageNetWorkSpeed: { download: 0, upload: 0 },
      people: '',
      dialog: {
        show: false,
        title: '',
        addclass: 'voicedialog'
      },
      timed: '00:00:00',
      userIdCard: '',
      currentStars: '',
      materiallist: [],
      uploadedUrl: [],
      alert: {
        show: false,
        info: '',
        recall: () => { }
      },
      infoupload: false,
      infouploadtxt: '',
      evaluate: false,
      recordGUID: null,
      peopleStreamName: null,
      userGUID: null,
      busy: null, // 占线
      callTimer: null,
      videoSetting: {},
      inAudioSetting: {},
      outAudioSetting: {},
      cid: 2,
      isconnecting: false,
      webRTCPlus: null,
      localStream: null,
      currentVideoMessage: null,
      rtcConnect: -1,
      socket: null,
      hangupMsg: null,
      primitiveStatus: '',
      status: '',
      messageUUID: '',
      connectType: 'video',
      allowVideo: true,
      allowVoice: true,
      prompt: {
        show: false,
        title: '提示',
        addclass: 'voicedialog'
      }
    }
  },
  computed: {
    keypage () {
      return String(new Date())
    },
    worktime () {
      const val = this.$point.config ? JSON.parse(this.$point.config) : {}
      return val.consult_worktime || ['09:00-18:00', '09:00-21:00']
    },
    noVideo () {
      const date = new Date();
      const worktime = this.worktime[0];
      const currentTime = new Date(date.setHours(...dayjs().format("HH:mm").split(':'), 0, 0));
      // 获取第一个工作时间段
      const [startTime, endTime] = worktime.split('-').map(time => {
        const [hours, minutes] = time.split(':');
        return new Date(date.setHours(hours, minutes, 0, 0));
      });
      return currentTime < startTime || currentTime > endTime
    },
    noVoice () {
      const date = new Date();
      const worktime = this.worktime[1];
      const currentTime = new Date(date.setHours(...dayjs().format("HH:mm").split(':'), 0, 0));
      const [startTime, endTime] = worktime.split('-').map(time => {
        const [hours, minutes] = time.split(':');
        return new Date(date.setHours(hours, minutes, 0, 0));
      });
      return currentTime < startTime || currentTime > endTime
    }
  },
  created () {
    this.setDeviceSettings()
    if (!Vue.prototype.$socket) {
      socketInitialization().then(socketInstance => {
        this.$socket = socketInstance
        console.log('$socket ready yn.')
      })
    }
  },
  beforeDestroy () {
    if (this.$socket) {
      this.$socket.disconnect();
      this.$socket = null;
    }
  },
  async mounted () {
    // try {
    //   const res = await getDeviceRule(window.localStorage.code)
    //   if (res && res.open) {
    //     this.allowVideo = !this.noVideo
    //     this.allowVoice = !true.noVoice
    //   } else {
    //     this.allowVideo = true;
    //     this.allowVoice = true;
    //   }
    // } catch (err) {
    // }
    await this.getNetSpeed()
    this.allowVideo = !this.noVideo
    this.allowVoice = !this.noVoice
    this.title = this.$route.query.title || '视频咨询'
    this.people = this.$route.query.people || '律师'
    if (this.$route.query.cid) {
      this.cid = this.$route.query.cid
    }
    document.querySelector('#waitAudio').pause()
    // this.demoCall(cid)

    this.webRTCPlus = new WebRTCPlus({
      role: "consumer",
      iceTransportPolicy: 'all', // 优先使用中继以提高连接稳定性
      iceServers: [
        {
          // TODO: 后续需要替换为服务器API传回
          urls: "stun:106.53.211.2:3478",
        },
        {
          urls: "turn:106.53.211.2:3478",
          username: "lvpintrun",
          credential: "J2hdi62kf2ud",
        },
      ],
      signalingBindFunction: (data) => {
        this.$socket.sendSignal(data);
      },
    });
    this.webRTCPlus.errorFunction = (data) => {
      // Dialog.alert({ type: "danger", message: data.msg });
      this.alert.info = data.msg
      this.alert.show = true
    };

    this.webRTCPlus.connectStateChangeFunction = (status) => {
      switch (status) {
        case "new":
        case "checking":
          this.rtcConnect = 1;
          break;
        case "connected":
          this.rtcConnect = 2;
          break;
        case "disconnected":
          this.rtcConnect = 1;
          break;
        case "closed":
          this.rtcConnect = 0;
          break;
        case "failed":
          this.rtcConnect = 1;
          break;
        default:
          this.rtcConnect = 1;
          break;
      }
    };

    this.webRTCPlus.remoteStreamUpdateFunction = async (
      streams
    ) => {
      if (
        streams &&
        streams[0] &&
        this.$refs.targetVideo.srcObject !== streams[0]
      ) {
        this.step = 2
        this.$nextTick(() => {
          document.querySelector('#waitAudio').pause()
        })
        this.$refs['self-video-container'].style.width = '200px'
        this.$refs['self-video-container'].style.height = 'auto'
        this.$refs.targetVideo.srcObject = streams[0];
        await this.$refs.targetVideo.play();
        this.startTimed()
      }
    };

    this.$socket && (this.$socket.signalUpdate = (data) => {
      this.webRTCPlus.signal(data);
    })

    emitter.on('rtc', async (data) => {
      console.log(this.currentVideoMessage.attribute.status)
      this.currentVideoMessage = data
      if (!this.currentVideoMessage) return;
      if (this.currentVideoMessage.attribute.status !== 10 && this.currentVideoMessage.attribute.status !== 20) {
        this.$nextTick(() => {
          document.querySelector('#waitAudio').pause()
        })
        if (this.webRTCPlus) {
          this.webRTCPlus.hangup();
        }
        if (this.localStream) {
          this.localStream.getTracks().forEach((track) => {
            track.stop();
          })
          this.localStream = null
        }
        if (
          (this.currentVideoMessage.attribute.status === 40 && this.primitiveStatus === 'receive') ||
          (this.currentVideoMessage.attribute.status === 41 && this.primitiveStatus === 'dial') ||
          (this.currentVideoMessage.attribute.status === 60 && this.primitiveStatus === 'receive') ||
          (this.currentVideoMessage.attribute.status === 61 && this.primitiveStatus === 'dial')
        ) {
          this.alert.info = '对方已挂断'
          this.alert.show = true
          this.step = 3
        } else if (
          (this.currentVideoMessage.attribute.status === 41 && this.primitiveStatus === 'receive') ||
          (this.currentVideoMessage.attribute.status === 40 && this.primitiveStatus === 'dial') ||
          (this.currentVideoMessage.attribute.status === 61 && this.primitiveStatus === 'receive') ||
          (this.currentVideoMessage.attribute.status === 60 && this.primitiveStatus === 'dial')
        ) {
          this.alert.info = '己方已挂断'
          this.alert.show = true
          this.step = 3
        } else if (
          (this.currentVideoMessage.attribute.status === 50 && this.primitiveStatus === 'receive') ||
          (this.currentVideoMessage.attribute.status === 51 && this.primitiveStatus === 'dial')
        ) {
          this.alert.info = '对方网路异常'
          this.alert.show = true
          this.step = 1
        } else if (
          (this.currentVideoMessage.attribute.status === 51 && this.primitiveStatus === 'receive') ||
          (this.currentVideoMessage.attribute.status === 50 && this.primitiveStatus === 'dial')
        ) {
          this.alert.info = '己方网路异常'
          this.alert.show = true
          this.step = 1
        } else if (this.currentVideoMessage.attribute.status === 23 || this.currentVideoMessage.attribute.status === 24 || this.currentVideoMessage.attribute.status === 42) {
          this.alert.info = '暂时无人接听，请稍后再试'
          this.alert.show = true
          this.step = 1
        } else if (this.currentVideoMessage.attribute.status === 21 || this.currentVideoMessage.attribute.status === 22) {
          this.alert.info = '当前对方不在线，请稍后再试'
          this.alert.show = true
          this.step = 1
        } else if (this.currentVideoMessage.attribute.status === 25 || this.currentVideoMessage.attribute.status === 26) {
          this.alert.info = '对方正在通话中，请稍后再试'
          this.alert.show = true
          this.step = 1
        } else if (this.currentVideoMessage.attribute.status >= 30 && this.currentVideoMessage.attribute.status < 40) {
          this.alert.info = this.currentVideoMessage.content || '未知错误'
          this.alert.show = true
          this.step = 1
        } else if (this.currentVideoMessage.attribute.status >= 70 && this.currentVideoMessage.attribute.status < 80) {
          this.alert.info = this.currentVideoMessage.content || '未知错误'
          this.alert.show = true
          this.step = 1
        }

        setTimeout(() => {
          if (this.alert.show) {
            this.alert.show = false
          }
        }, 2000);
      } else if (this.currentVideoMessage.attribute.status === 10) {
        // this.status = "receive";
        // this.primitiveStatus = "receive"
        // window.roomName = data.toRoom;
        // this.messageUUID = data.uuid;
        // this.localStream =
        //   await window.navigator.mediaDevices.getUserMedia({
        //     video: data.attribute.connectType === 'video',
        //     audio: {
        //       noiseSuppression: true, // 降噪
        //       echoCancellation: true, // 回音消除
        //     },
        //   });
        // if (this.localStream) {
        //   this.$refs.selfVideo.srcObject = this.localStream;
        //   this.$nextTick(() => {
        //     document.querySelector('#waitAudio').play()
        //   })
        // }
      } else if (this.currentVideoMessage.attribute.status === 20) {
        this.currentVideoMessage.attribute.status = 20
        this.status = "pending";
        this.alert.info = '建立通话中'
        this.alert.show = true
        setTimeout(() => {
          if (this.alert.show) {
            this.alert.show = false;
          }
        }, 800);
      }
    })

    emitter.on('updateMessageAttributeCallback', (data) => {
      if (data.type === 'rtc' && data.status === 20) {
        this.status = "pending";
        nextTick(() => {
          if (this.webRTCPlus && this.localStream)
            this.webRTCPlus.answer(window.roomName);
        });
      }
    })
  },
  beforeDestroy () {
    document.querySelector('#waitAudio').pause()
    this.$rtc.reset()
  },
  beforeRouteLeave (to, from, next) {
    this.$destroy() // 销毁vue 实例
    next()
  },
  methods: {
    setDeviceSettings () {
      this.videoSetting = JSON.parse(window.localStorage.getItem('videoSetting') || '{}')
      this.inAudioSetting = JSON.parse(window.localStorage.getItem('inAudioSetting') || '{}')
      this.outAudioSetting = JSON.parse(window.localStorage.getItem('outAudioSetting') || '{}')
    },
    async getNetSpeed () {
      this.averageNetWorkSpeed = await testNetworkSpeed()
      console.log(this.averageNetWorkSpeed)
    },
    // 语音咨询
    voiceCall () {
      if (this.averageNetWorkSpeed.download < 1 && this.averageNetWorkSpeed.upload < 1) {
        this.alert.info = '您的网络条件较差，请更换网络后重试。或拨打「12348」热线进行咨询'
        this.alert.show
      } else {
        const deviceType = this.$store.state.device.point.device_type
        if (this.allowVoice) {
          this.status = 'dial';
          this.primitiveStatus = 'dial';
          this.connectType = 'audio';
          this.messageUUID = generateUUID();
          if (deviceType === 7) {
            // 壁挂机不显示提示
            this.rtcConnectFunction()
          } else {

            this.prompt.show = true;
          }
        } else {
          this.alert.info = '当前时间段，无法进行语音咨询'
          this.alert.show
        }
      }
    },
    // 视频咨询
    demoCall () {
      if (this.averageNetWorkSpeed.download < 2 && this.averageNetWorkSpeed.upload < 2) {
        this.voiceCall();
      } else {
        const deviceType = this.$store.state.device.point.device_type
        if (this.allowVideo) {
          this.status = 'dial';
          this.primitiveStatus = 'dial';
          this.connectType = 'video';
          this.messageUUID = generateUUID();
          // await this.rtcConnectFunction();
          if (deviceType === 7) {
            // 壁挂机不显示提示
            this.rtcConnectFunction()
          } else {
            this.prompt.show = true;
          }
        } else {
          this.alert.info = '当前时间段，无法进行视频咨询'
          this.alert.show
        }
      }
    },
    async rtcConnectFunction () {
      let constraints = {
        audio: {
          noiseSuppression: true, // 降噪
          echoCancellation: true, // 回音消除
        },
        video: true,
      };
      try {
        this.localStream = await navigator.mediaDevices.getUserMedia(
          constraints
        );

        this.step = 2
        this.$refs['self-video-container'].style.width = '100%'
        this.$refs['self-video-container'].style.height = '100%'
        this.$refs.selfVideo.srcObject = this.localStream;
        await this.$refs.selfVideo.play();

        this.webRTCPlus.init([this.localStream]);

        this.$nextTick(() => {
          document.querySelector('#waitAudio').src = 'https://qiniu.terminal.laway.cn/wait.mp3'
          document.querySelector('#waitAudio').play()
        })
        const msg = {
          uuid: this.messageUUID,
          content: "",
          attribute: {
            channelId: 2,
            launchUser: "consumer",
            status: 10,
            startTime: new Date(),
            endTime: null,
            connectType: this.connectType
          },
          type: 'rtc',
          roomName: window.roomName,
          sendTime: new Date(),
        };

        this.currentVideoMessage = msg

        this.$socket && this.$socket.emit("sendMsg", msg);
      } catch (err) {
        console.log(err, 'err')
        // 异常情况处理,MIC异常
        this.alert.info = `获取摄像头或麦克风权限失败(${err})`
        this.alert.show = true
      }
    },
    // 数据传输频道
    initDataChannel () {
      easyrtc.setPeerListener(async (who, msgType, content) => {
        if (
          msgType === 'link' &&
          this.step !== 3 &&
          !this.recordGUID &&
          !this.userGUID
        ) {
          this.userGUID = content
          this.$requestService
            .post('/api/record/start', {
              userGUID: content, // 律师GUID
              customerID: this.userIdCard // 用户身份证号
            })
            .then(res => {
              this.recordGUID = res.data.result.recordGUID
              easyrtc.sendDataWS(who, 'link', {
                recordGUID: this.recordGUID,
                userIdCard: this.userIdCard,
                code: window.localStorage.code
              })
            })
            .catch(err => {
              console.log('recordstart失败')
              console.log(err)
            })
        }
        // 打开扫描仪
        if (msgType === 'showFileScan' && this.step === 2) {
          await this.scanstartVedio('scan')
          this.dialog.show = true
        }

        // 打印pdf
        if (msgType === 'print') {
          const res = JSON.parse(content)
          const printA4Name = window.localStorage.getItem('printA4Name')
          this.$electron.ipcRenderer.send('printRemoteFile', res.fileurl, printA4Name)
        }
      })
    },
    stopStreamedVideo (videoElem) {
      if (videoElem) {
        let stream = videoElem.srcObject
        let tracks = stream.getTracks()
        tracks.forEach(function (track) {
          track.stop()
        })
        videoElem.srcObject = null
      }
    },
    closeUploadinfo () {
      this.infoupload = false
    },
    closeDialog () {
      // 关闭弹窗
      this.dialog.show = false
      this.$loading.hide()
      this.uploadedUrl = []
      this.materiallist = []
    },
    showScan () {
      this.dialog.show = true
      this.$nextTick(() => {
        this.scanstartVedio('scan')
      })
    },
    goback () {
      console.log(this.step, 'seppp')
      this.hangup()
      if (this.step === 4) {
        this.$router.push('/home')
      } else {
        this.$router.go(-1)
        setTimeout(() => {
          this.$scrollTo(0)
        }, 0)
      }
      this.step -= 1
    },
    reCall () {
      this.messageUUID = '';
      this.currentVideoMessage = null;
      this.primitiveStatus = '';
      this.status = '';
      this.connectType = '';
      this.step = 1;
    },
    init () {
      this.userIdCard = this.$store.state.user.idCardResult.id // 用户身份证

      this.closeAllLocalVideo()
      this.recordGUID = null
      this.userGUID = null
      this.nowEasyrtcid = null

      const outAudioSetting = JSON.parse(window.localStorage.outAudioSetting)
      this.outAudioSetting = outAudioSetting

      const videoSetting = JSON.parse(window.localStorage.videoSetting)
      this.videoSetting = videoSetting

      const printA4Name = window.localStorage.printA4Name; // eslint-disable-line

      speak(
        `请使用设备侧方的话筒与${this.people}进行对话`,
        this.outAudioSetting['open'].deviceId
      )

      easyrtc.setStreamAcceptor((easyrtcid, stream, streamName) => {
        this.nowEasyrtcid = easyrtcid
        // easyrtc.setRoomApiField('default', 'on', 'ok')
        console.log('接线成功')
        this.nextStep(2)
        this.startTimed()
        // 远程摄像头
        this.addMediaStreamToDiv('lawyer', stream, streamName, false)
        console.log('accepted incoming stream with name ' + stream.streamName)
        console.log(
          'checking incoming ' +
          easyrtc.getNameOfRemoteStream(easyrtcid, stream)
        )
        this.busy = setInterval(() => {
          easyrtc.sendDataWS(
            {
              targetRoom: 'default'
            },
            'live',
            easyrtcid
          )
        }, 1000)
      })

      easyrtc.setPeerListener(async (who, msgType, content) => {
        console.log(who, msgType, content, '2setPeerListener')
        if (
          msgType === 'link' &&
          this.step !== 3 &&
          !this.recordGUID &&
          !this.userGUID
        ) {
          this.userGUID = content
          this.$requestService
            .post('/api/record/start', {
              userGUID: content, // 律师GUID
              customerID: this.userIdCard // 用户身份证号
            })
            .then(res => {
              console.log(res.data.result.recordGUID)
              this.recordGUID = res.data.result.recordGUID
              easyrtc.sendDataWS(who, 'link', {
                recordGUID: this.recordGUID,
                userIdCard: this.userIdCard,
                code: window.localStorage.code
              })
            })
            .catch(err => {
              console.log('recordstart失败')
              console.log(err)
            })
        }
        if (msgType === 'showFileScan' && this.step === 2) {
          this.dialog.show = true
        }

        if (msgType === 'print') {
          const res = JSON.parse(content)
        }
      })

      easyrtc.setOnStreamClosed((easyrtcid, stream, streamName) => {
        this.endSys()
      })

      easyrtc.setCallCancelled(easyrtcid => {
        // if (easyrtcid === callerPending) {
        //   // 等待中。。。
        // }
      })

      easyrtc.setAcceptChecker((easyrtcid, callback) => {
        console.log('收到请求 setAcceptChecker')
        console.log(easyrtcid)
        callback(true, easyrtc.getLocalMediaIds()); // eslint-disable-line
      })
      easyrtc.setSocketUrl('https://terminal.wulvshi.com/')
      easyrtc.enableVideo(true)
      easyrtc.enableVideoReceive(true)
      easyrtc.setVideoDims(640, 480)
      easyrtc.enableDebug(true)
      easyrtc.setAutoInitUserMedia(false)
      easyrtc.getVideoSourceList(videoSrcList => {
        this.startVedio('person', videoSetting['personA'].deviceId, 'person')
        this.scanstartVedio('scan')
      })
    },
    async addMediaStreamToDiv (divId, stream, streamName, isLocal) {
      const container = document.createElement('div')
      container.style.marginBottom = '10px'
      const video = document.createElement('video')
      video.width = 640
      video.height = 480
      video.muted = isLocal
      video.style.verticalAlign = 'middle'
      // 远程语音信息
      if (divId === 'lawyer') {
        await this.$jsMediaDevices.setOutAudioDevices(
          video,
          this.outAudioSetting['microphone'].deviceId
        )
      }
      container.appendChild(video)
      document.getElementById(divId).innerHTML = ''
      document.getElementById(divId).appendChild(container)
      video.autoplay = true
      easyrtc.setVideoObjectSrc(video, stream)
      return divId
    },
    endSys () {
      this.endTimed()
      window.clearInterval(this.busy)
      // this.disconnect()
      this.closeDialog()
      // easyrtc.closeLocalMediaStream()
      this.nextStep(3)
    },
    hangup () {
      // this.isconnecting = true
      // this.$rtc.reset()
      // this.endSys()
      document.querySelector('#waitAudio').pause()
      const rtcStatus = (this.primitiveStatus === "receive" ?
        (this.status === "pending" ? 61 : 41) :
        (this.status === "pending" ? 60 : 40)
      )
      this.currentVideoMessage.attribute.status = rtcStatus;
      this.currentVideoMessage.attribute.endTime = new Date();
      console.log(this.$socket, 'this.$socket')
      this.$socket.emit("updateMessageAttribute", {
        type: 'rtc',
        roomName: window.roomName,
        uuid: this.currentVideoMessage.uuid,
        attribute: this.currentVideoMessage.attribute,
      });
      if (this.webRTCPlus) this.webRTCPlus.hangup();

      if (this.localStream) {
        this.localStream.getTracks().forEach((track) => {
          track.stop();
        });
      }
      this.alert.info = '已挂断'
      this.alert.show = true
      this.endSys()
    },
    disconnect () {
      easyrtc.disconnect()
    },
    closeLocalVideo (streamName) {
      easyrtc.closeLocalStream(streamName)
    },
    async createLocalVideo (stream, streamName, action) {
      // 开启摄像头
      await this.addMediaStreamToDiv(action, stream, streamName, true)
    },
    startVedio (buttonLabel, videoId, type) {
      // 开启某个摄像头
      easyrtc.setVideoSource(videoId)
      console.log('开启摄像头')
      easyrtc.initMediaSource(
        async stream => {
          await this.createLocalVideo(stream, buttonLabel, type)
          easyrtc.connect(
            'terminal',
            easyrtcid => {
              console.log('I am ' + easyrtc.cleanId(easyrtcid))
            },
            (errorCode, message) => {
              console.log(errorCode, message)
            }
          )
          this.peopleStreamName = stream.streamName
        },
        function (errCode, errText) {
          console.log(errCode, errText)
        },
        type
      )
    },
    addStreamToCall (otherEasyrtcid, buttonLabel) {
      console.log('6asdadadas')
      easyrtc.addStreamToCall(otherEasyrtcid, buttonLabel, function (
        easyrtcid,
        streamName
      ) {
        console.log(
          'Informational',
          'other party ' + easyrtcid + ' acknowledges receiving ' + streamName
        )
      })
    },
    closeAllLocalVideo () {
      if (this.peopleStreamName) {
        this.closeLocalVideo(this.peopleStreamName)
      }

      const personVideo = document.getElementById('person')
      const lawyerVideo = document.getElementById('lawyer')
      if (
        personVideo &&
        personVideo.children[0] &&
        personVideo.children[0].getElementsByTagName('video')
      ) {
        this.stopStreamedVideo(
          personVideo.children[0].getElementsByTagName('video')[0]
        )
      }

      if (
        lawyerVideo &&
        lawyerVideo.children[0] &&
        lawyerVideo.children[0].getElementsByTagName('video')
      ) {
        this.stopStreamedVideo(
          lawyerVideo.children[0].getElementsByTagName('video')[0]
        )
      }

      const ids = ['person', 'people', 'file', 'scan']
      for (const i in ids) {
        if (document.getElementById(ids[i])) {
          document.getElementById(ids[i]).innerHTML = ''
        }
      }
    },
    nextStep (step) {
      if (step) {
        this.step = step
      } else {
        this.step++
      }
      if (this.step === 2) {
        const personElement = document.getElementById('person')
        personElement.style.width = '200px'
        personElement.style.height = '150px'
        const video = personElement.children[0].getElementsByTagName(
          'video'
        )[0]
        video.width = 200
        video.height = 150
      }
    },
    startTimed () {
      let c = 0
      this.interval = window.setInterval(() => {
        c++
        let hour = parseInt(c / 3600) // 小时数
        let min = parseInt(c / 60) // 分钟数
        if (min >= 60) {
          min = min % 60
        }
        let lastsecs = c % 60
        if (hour < 10) hour = '0' + hour
        if (min < 10) min = '0' + min
        if (lastsecs < 10) lastsecs = '0' + lastsecs
        this.timed = hour + ':' + min + ':' + lastsecs
      }, 1000)
    },
    endTimed () {
      window.clearInterval(this.interval)
    },
    async uploadImg (base64) {
      const blob = dataURLtoBlob(base64)
      const uploadUrl = 'https://api.terminal.wulvshi.com/api/upload/img'
      const fd = new window.FormData()
      fd.append('img', blob, 'a.jpeg')
      const response = await fetch(uploadUrl, { method: 'post', body: fd })
      if (response.status !== 200) {
        this.showMsg('上传失败，请重新上传')
      }
      const res = await response.json()
      if (res.status === 1) {
        return res.result.realPath
      } else {
        return false
      }
    },
    async sendEvaluate () {
      if (!this.currentStars) {
        return
      }
      const res = await confirmEvaluate({ messageUUID: this.currentVideoMessage.uuid, rate: this.currentStars, content: '', time: new Date().toString() })
      // this.$requestService.post('/api/remark/add', {
      //   userGUID: this.userGUID, // 律师
      //   recordGUID: this.recordGUID,
      //   stars: this.currentStars, // 星级
      //   tips: '[]'
      // })
      if (res) {
        this.step = 4
      }
    },
    // 扫描创建
    async scanstartVedio (divId) {
      // 启动高拍仪
      console.log('启动高拍仪')
      const stream = await this.$jsMediaDevices.getVideoMedia(
        this.videoSetting['scan'].deviceId,
        {
          height: 1080,
          width: 1920
        }
      )
      this.scanaddMediaStreamToDiv(divId, stream, true)
    },
    scanaddMediaStreamToDiv (divId, stream, isLocal) {
      var video = document.createElement('video')
      const container = document.getElementById(divId)
      video.width = 960
      video.height = 540
      video.muted = isLocal
      video.style.verticalAlign = 'middle'
      container.innerHTML = ''
      container.appendChild(video)
      video.autoplay = true
      video.srcObject = stream
      return divId
    },
    takePicture (sourceId) {
      let canvas = document.createElement('canvas')
      let sourceObject = document
        .getElementById(sourceId)
        .getElementsByTagName('video')[0]
      canvas.width = 960
      canvas.height = 540
      let ctx = canvas.getContext('2d')
      ctx.drawImage(sourceObject, 0, 0, canvas.width, canvas.height)
      this.sourceObject = sourceObject
      this.canvas = canvas
      return canvas.toDataURL('image/jpeg')
    },
    getScanning () {
      const nowPreview = this.takePicture('scan')
      this.materiallist.push(nowPreview)
      this.uploadImg(nowPreview).then(r => {
        this.uploadedUrl.push(r)
      })
    },
    deletePhoto (index, list) {
      removeByValue(list, list[index])
    },
    sendToLawyer (arr) {
      // 关闭模态框
      // 发送逻辑
      easyrtc.sendDataWS(this.nowEasyrtcid, 'scanResult', JSON.stringify(arr))
      this.closeDialog()
      this.alert.info = '提交成功'
      this.alert.show = true
    },
    sendToLawyerClick (arr) {
      if (!arr.length) {
        return
      }
      this.$loading.show()
      if (
        arr.every(val => val !== false) &&
        arr.length === this.materiallist.length
      ) {
        console.log('上传成功')
        window.setTimeout(() => {
          this.$loading.hide()
          this.sendToLawyer(arr)
        }, 1500)
      } else {
        // loading... 不允许进行任何操作
        this.$loading.show()
        let time = 0
        var intervalNum = window.setInterval(async () => {
          if (arr.every(val => val !== false)) {
            window.clearInterval(intervalNum)
            this.$loading.hide()
            this.sendToLawyer(arr)
          } else {
            this.alert.info = '网络异常，部分文件传输失败，正在重试，请稍等。'
            this.alert.show = true
            const tmp = []
            for (const n in this.materiallist) {
              tmp.push(this.uploadImg(this.materiallist[n]))
            }
            const res = await Promise.all(tmp)
            if (res) {
              this.$loading.hide()
              window.clearInterval(intervalNum)
              this.sendToLawyer(res)
            } else {
              // 提示用户（需要用户确定）：
              this.$loading.hide()
              window.clearInterval(intervalNum)
              this.infoupload = true
              this.infouploadtxt =
                '网络异常，文件发送失败，请联系现场工作人员。'
            }
          }
          if (time === 20) {
            window.clearInterval(intervalNum)
            this.$loading.hide()
            // 提示用户（需要用户确定）：网络较差，文件发送失败，请联系现场工作人员。
            window.clearInterval(intervalNum)
            this.infoupload = true
            this.infouploadtxt = '网络较差，文件发送失败，请联系现场工作人员。'
          } else {
            time++
          }
        }, 1000)
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.content
  padding 1.2rem 2.65rem 0 2.94rem
  display flex
  justify-content space-between
  .videoconsult
    position relative
    width 520px
    .default-lawyer
      width 100%
      height 600px
      background rgba(255, 255, 255, 0.3) url('/img/ui/lawyer_avatar.png') center center no-repeat
      // background rgba(255,255,255,0.3) url('/img/ui/video-prompt.jpg') center center no-repeat
      // background-size cover
      border 2px solid rgba(255, 255, 255, 0.3)
      border-radius 0.1rem
    .default-mike
      width 100%
      height 600px
      background rgba(255, 255, 255, 0.3) url('/img/ui/mike.png') center center no-repeat
      background-size 300px 300px
      border 2px solid rgba(255, 255, 255, 0.3)
      border-radius 0.1rem
    .target-video-container
      display flex
      align-items center
      justify-content center
      border-radius 0.1rem
      transform rotateY(180deg)
      video
        width 100%
        object-fit cover
    .self-video-container
      position absolute
      top 0
      right 0px
      width 200px
      z-index 999
      video
        display block
        width 100%
        height auto
  .info
    height 5rem
    display flex
    justify-content center
    flex-direction column
    font-size 0.4rem
    letter-spacing 1px
    color #fff
    .tip
      margin-top 0.1rem
      font-size 0.3rem
  .intro
    flex 1
    box-sizing border-box
    position relative
    padding-left 0.99rem
    font-size 0.3rem
    color #fff
    .lawyer
      font-size 0.4rem
      line-height 0.4rem
      margin-top 0.3rem
      span
        font-size 0.28rem
    .organ
      font-size 0.3rem
      line-height 0.3rem
      margin-top 0.29rem
    .voicestatus
      font-size 0.34rem
      line-height 1.6
      font-size 0.3rem
      margin 2.1rem 0 1.02rem 0.4rem
      span
        font-size 0.32rem
        color #ffb23c
    .btns
      display flex
      margin-bottom 20px
      align-items center
      letter-spacing 1px
      font-size 18px
    .button
      width 2.77rem
      height 0.9rem
      background-color #33c339
      border-radius 0.1rem
      color #fff
      font-size 0.34rem
      text-align center
      line-height 0.9rem
      border 0
      margin-right 5px
      &.active
        margin-left 0.3rem
        background-color #ec3839
  .evaluation
    padding 0.69rem
    flex 1
    text-align center
    color #fff
    .title
      font-size 0.42rem
    .voicetime
      line-height 1
      padding 0.28rem 0 1rem 0
      font-size 0.26rem
      span
        color #ffb23c
    .evaluation-con
      display flex
      justify-content space-between
      width 8.8rem
      margin 0 auto
      .item
        width 1.86rem
        color #fff
        font-size 0.3rem
        .imgs
          width 0.94rem
          height 0.94rem
          text-align center
          line-height 0.94rem
          margin 0 auto 0.3rem auto
          border-radius 50%
          background-color rgba(255, 255, 255, 0.2)
          img
            height 0.45rem
            object-fit cover
        &.active
          .imgs
            background-color #09bd5c
    .button
      width 2.7rem
      height 0.9rem
      margin 1.2rem auto 0 auto
      background-color #fc9d0b
      border-radius 0.1rem
      color #fff
      font-size 0.34rem
      text-align center
      line-height 0.9rem
      border 0
.uploadinfo
  position absolute
  top 0
  left 0
  right 0
  bottom 0
  z-index 99999999999999
  .masks
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    background rgba(0, 0, 0, 0.4)
  .infocontent
    position absolute
    top 50%
    left 50%
    transform translate(-50%, -50%)
    background #fff
    border-radius 0.08rem
    padding 0.3rem
    width 5rem
  .infotitle
    font-size 0.3rem
    padding 0 0 0.3rem 0
    text-align center
  .infotxt
    text-align center
    font-size 0.26rem
  button
    display block
    margin 0.2rem auto
    width 1.78rem
    height 0.46rem
    background-color #2f5ccd
    border-radius 0.1rem
    color #fff
    border 0
    font-size 0.3rem
</style>
